<template>
  <div class="bg-white">
    <CoverPage />
    <!-- <h2 class="text-center text-black font-semibold fsize35">
      Partner with us as a
    </h2>
    <div class="flex gap-20 justify-center pt-3">
      <p
        @click="handlevol()"
        class="onhoverul cursor-pointer text-primary fsize20"
      >
        Volunteer
      </p>
      <p
        @click="handledon()"
        class="onhoverul cursor-pointer text-primary fsize20"
      >
        Donor
      </p>
      <p
        @click="handlecar()"
        class="onhoverul cursor-pointer text-primary fsize20"
      >
        Career
      </p>
      <p
        @click="handleinter()"
        class="onhoverul cursor-pointer text-primary fsize20"
      >
        Intern
      </p>
      <p
        @click="handlepart()"
        class="onhoverul cursor-pointer text-primary fsize20"
      >
        Parnter
      </p> 
    </div>-->
    <div class="relative z-index1 h-full w-full">
      <div class="container md:px-5 px-6">
        <!-- sm-joinus-svg -->
        <!-- <div
          class="absolute w-full md:hidden lg:hidden block z-index--1 h-full"
        >
          <img
            src="./../../assets/images/bg-des/joinus-bg.svg"
            alt="bg-polygon"
            class="w-full h-full"
          />
        </div> -->
        <ContactUs />
        <Donate />
        <Career />
        <Careers2 />
        <!-- <ContactUs2 /> -->
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import ContactUs from "./components/ContactUs.vue";
import Donate from "./components/Donate.vue";
import Career from "./components/Careers.vue";
import ContactUs2 from "./components/ContactUs2.vue";
import Careers2 from "./components/Careers2.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    CoverPage,
    ContactUs,
    Donate,
    DownloadApp,
    Footer,
    Career,
    ContactUs2,
    Careers2,
  },
  metaInfo: {
    title: "Join us at Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Volunteering. Internships. Partnerships. You can help us make a difference in the lives of caregivers in need.",
      },
    ],
  },
  methods: {
    handlevol() {
      const el = document.getElementById("joinvolunteer");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handledon() {
      const el = document.getElementById("joindonor");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlecar() {
      const el = document.getElementById("joincareers");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleinter() {
      const el = document.getElementById("internjoin");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handlepart() {
      const el = document.getElementById("joinpartner");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>
<style>
.onhoverul:hover {
  text-decoration: underline;
}
</style>
